export interface CartPrice {
  price?: string | number;
  unitAmountGrosze?: number;
}

/** Accept catalog decimal prices and the PLN labels saved by older carts. */
export function priceAmountGrosze(price: unknown): number | null {
  if (typeof price === 'number') {
    if (!Number.isFinite(price) || price < 0) return null;
    const amount = Math.round(price * 100);
    return Number.isSafeInteger(amount) && Math.abs(price * 100 - amount) < 0.000001 ? amount : null;
  }
  if (typeof price !== 'string') return null;
  const value = price.trim().replace(/\s*(?:zł|PLN)$/i, '').trim();
  if (!/^(?:\d+|\d{1,3}(?:[ \u00a0\u202f]\d{3})+)(?:[.,]\d{1,2})?$/.test(value)) return null;
  const [whole, decimal = ''] = value.replace(/[ \u00a0\u202f]/g, '').replace(',', '.').split('.');
  const amount = Number(whole) * 100 + Number(decimal.padEnd(2, '0'));
  return Number.isSafeInteger(amount) && amount >= 0 ? amount : null;
}

/** The numeric amount wins over its display label. Invalid explicit amounts fail closed. */
export function cartItemAmountGrosze(item: CartPrice): number | null {
  if (item.unitAmountGrosze !== undefined) {
    return Number.isSafeInteger(item.unitAmountGrosze) && item.unitAmountGrosze >= 0
      ? item.unitAmountGrosze
      : null;
  }
  return priceAmountGrosze(item.price);
}

export function withCartAmount<T extends CartPrice>(item: T): T {
  const amount = cartItemAmountGrosze(item);
  return amount === null ? item : { ...item, unitAmountGrosze: amount };
}
